import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { RadarChart, Radar, PolarGrid, PolarAngleAxis, ResponsiveContainer } from 'recharts';
import { Award } from 'lucide-react';
import { cn } from '@/lib/utils';

interface QualityScores {
  tempoPreenchimento: number;
  dispositivo: number;
  conversao: number;
  completude: number;
  scoreGeral: number;
}

interface LeadCardQualidadeScoreProps {
  scores: QualityScores;
  className?: string;
}

export function LeadCardQualidadeScore({ scores, className }: LeadCardQualidadeScoreProps) {
  useLanguage();
  const radarData = [
    { subject: 'Tempo', value: scores.tempoPreenchimento, fullMark: 100 },
    { subject: 'Dispositivo', value: scores.dispositivo, fullMark: 100 },
    { subject: 'Conversão', value: scores.conversao, fullMark: 100 },
    { subject: 'Completude', value: scores.completude, fullMark: 100 }
  ];

  return (
    <Card className={cn("rounded-[14px] shadow-sm hover:shadow-md transition-shadow min-h-[160px]", className)}>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground">
          {translateInterfaceText("Qualidade dos Leads (Score)")}</CardTitle>
        <Award className="h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent>
        <div className="flex items-center gap-6">
          <div className="flex-1">
            <div className="flex items-baseline gap-2 mb-4">
              <p className="text-3xl font-bold">{scores.scoreGeral}</p>
              <span className="text-sm text-muted-foreground">/ 100</span>
            </div>
            
            <div className="space-y-2">
              <div className="flex items-center justify-between text-xs">
                <span className="text-muted-foreground">{translateInterfaceText("Tempo de preenchimento")}</span>
                <span className="font-semibold">{scores.tempoPreenchimento}</span>
              </div>
              <div className="flex items-center justify-between text-xs">
                <span className="text-muted-foreground">{translateInterfaceText("Dispositivo principal")}</span>
                <span className="font-semibold">{scores.dispositivo}</span>
              </div>
              <div className="flex items-center justify-between text-xs">
                <span className="text-muted-foreground">{translateInterfaceText("Conversão final")}</span>
                <span className="font-semibold">{scores.conversao}</span>
              </div>
              <div className="flex items-center justify-between text-xs">
                <span className="text-muted-foreground">{translateInterfaceText("Completude dos dados")}</span>
                <span className="font-semibold">{scores.completude}</span>
              </div>
            </div>
          </div>
          
          <div className="w-[200px] h-[180px]">
            <ResponsiveContainer width="100%" height="100%">
              <RadarChart data={radarData}>
                <PolarGrid stroke="#E5E7EB" />
                <PolarAngleAxis 
                  dataKey="subject" 
                  tick={{ fill: '#6B7280', fontSize: 11 }}
                />
                <Radar 
                  name="Score" 
                  dataKey="value" 
                  stroke="#2F6FED" 
                  fill="#2F6FED" 
                  fillOpacity={0.3}
                />
              </RadarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
